import { BeRow, BeWindowTab } from "@beos-css/react/index.ts";

export function WindowTabDemo() {
	return (
		<section id="demo-window-tab">
			<h2>Window tab (decoration on its own)</h2>
			<p>
				Just the tab decoration (<code>.be-window-tab</code>, no window body) -- the Figma "Window Decoration" variant set. Active (yellow)
				and inactive (grey) keep the 1px seam strip that merges a selected tab into the window body; <code>unselected</code> (a stacked tab
				that isn't the front one) drops the strip. The tab is content-sized: no zoom button means an 18px-narrower tab, like R5.
			</p>
			<BeRow wrap gap="row">
				<BeWindowTab title="Active" onClose={() => {}} onZoom={() => {}} />
				<BeWindowTab inactive title="Inactive" onClose={() => {}} onZoom={() => {}} />
				<BeWindowTab state="unselected" title="Unselected" onClose={() => {}} onZoom={() => {}} />
			</BeRow>
			<BeRow wrap gap="row">
				<BeWindowTab title="Close only" onClose={() => {}} />
				<BeWindowTab title="Dialog (no buttons)" />
			</BeRow>
		</section>
	);
}
